import { render, staticRenderFns } from "./BlockedItemsList.vue?vue&type=template&id=848a6ab0"
import script from "./BlockedItemsList.vue?vue&type=script&lang=js"
export * from "./BlockedItemsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports